import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  NativeSelect,
  Stack
} from '@mui/material';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import ClearIcon from '@mui/icons-material/Clear';
import MDInput from 'components/MDInput';
import { useGetAccountsQuery } from 'services/accountApi';

export function AccountNodeForm({ id, data, onUpdateData }) {
  const { formatMessage: msg } = useIntl();

  // Fetch providers from API
  const { data: accounts = [], isLoading: accountsLoading } = useGetAccountsQuery();

  const { control, setValue, watch } = useForm({
    defaultValues: {
      accountId: data?.accountId || '',
      outputVar: data?.outputVar || 'account'
    }
  });

  const formValues = watch();

  useEffect(() => {
    const updatedData = {
      ...data,
      accountId: formValues.accountId,
      outputVar: formValues.outputVar
    };

    onUpdateData?.({
      id,
      data: updatedData
    });
  }, [formValues, data, onUpdateData, id]);

  const clearField = (fieldName) => {
    setValue(fieldName, '');
  };

  return (
    <Stack spacing={1} sx={{ p: 1 }}>
      <Controller
        name="accountId"
        control={control}
        render={({ field }) => (
          <FormControl fullWidth>
            <InputLabel variant="standard" htmlFor="provider-native-select">
              {msg({ id: 'field.account.label' })}
            </InputLabel>
            {accountsLoading ? (
              <CircularProgress size={24} />
            ) : (
              <NativeSelect
                {...field}
                label={msg({ id: 'field.account.label' })}
                required
                inputProps={{
                  id: 'provider-native-select',
                  name: 'accountId'
                }}
              >
                <option value="0">Sélectionner un compte</option>
                {accounts.map((account) => (
                  <option key={account.id} value={account.id}>
                    {account.label}
                  </option>
                ))}
              </NativeSelect>
            )}
          </FormControl>
        )}
      />
      <Controller
        name="outputVar"
        control={control}
        render={({ field }) => (
          <MDInput
            {...field}
            label={msg({ id: 'field.outputvar.label' })}
            variant="filled"
            fullWidth
            size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msg({ id: 'tooltip.clear' })}>
                    <IconButton onClick={() => clearField('outputVar')}>
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        )}
      />
    </Stack>
  );
}

AccountNodeForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.shape({
    accountId: PropTypes.string,
    outputVar: PropTypes.string
  }),
  onUpdateData: PropTypes.func.isRequired
};
